import React from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../../context/SettingsContext';
import { formatDate } from '../../utils/format';
import Image from '../common/Image';

export function BlogCard({ post, blogSlug = 'news' }) {
  return (
    <article className="sf__article-card">
      <Link to={`/blogs/${blogSlug}/${post.slug}`} className="block sf__hover-scale-up overflow-hidden rounded-[5px]">
        <Image src={post.image} alt={post.title} ratio={1.5} imgClassName="w-full h-full object-cover" />
      </Link>
      <div className="mt-5">
        <div className="text-sm text-color-secondary flex items-center flex-wrap gap-x-3">
          {post.category && <Link to={`/blogs/${blogSlug}?category=${encodeURIComponent(post.category)}`} className="font-medium text-black">{post.category}</Link>}
          <span>{formatDate(post.publishedAt)}</span>
        </div>
        <h3 className="text-xl font-medium mt-2 mb-3 leading-snug"><Link to={`/blogs/${blogSlug}/${post.slug}`} className="hover:text-color-secondary">{post.title}</Link></h3>
        {post.excerpt && <p className="text-color-secondary truncate-lines" style={{ '--product-title-line-clamp': 3 }}>{post.excerpt}</p>}
        <Link to={`/blogs/${blogSlug}/${post.slug}`} className="sf__btn sf__btn-link mt-3 inline-block">Read more</Link>
      </div>
    </article>
  );
}

export default function BlogPosts({ section }) {
  const { settings } = useSettings();
  const d = section.data || {};
  const posts = section.posts || [];
  if (!posts.length) return null;
  const cols = Number(d.columns) || 3;
  return (
    <section className="sf__blog-posts">
      <div className="container-fluid section-my">
        <div className="section__header text-center">
          {d.subheading && <p className="section__subheading">{d.subheading}</p>}
          <h2 className="section__heading">{d.heading || 'Blog posts'}</h2>
        </div>
        <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-${cols} gap-x-8 gap-y-12`}>
          {posts.map((p) => (
            <BlogCard key={p._id} post={p} blogSlug={settings.pages?.blogSlug || 'news'} />
          ))}
        </div>
        {d.showButton !== false && (
          <div className="text-center mt-12">
            <Link to={`/blogs/${settings.pages?.blogSlug || 'news'}`} className="sf__btn sf__btn-secondary">{d.buttonText || 'View all posts'}</Link>
          </div>
        )}
      </div>
    </section>
  );
}
